// extracted by mini-css-extract-plugin
export var button = "_df-7";
export var buttonRow = "_df-6";
export var fadeIn = "_df-1";
export var gradient = "_df-0";
export var panel = "_df-2";
export var panelIn = "_df-3";
export var subtitle = "_df-5";
export var title = "_df-4";